import api from "./api";

// Fetch all users
export const fetchUsers = async () => {
  const res = await api.get("/users/");
  return res.data;
};

// Create new user
export const createUser = async (user) => {
  const res = await api.post("/users/", user);
  return res.data;
};

// Update existing user
export const updateUser = async (id, user) => {
  const res = await api.put(`/users/${id}/`, user);
  return res.data;
};

// Delete user
export const deleteUser = async (id) => {
  const res = await api.delete(`/users/${id}/`);
  return res.data;
};
